// @ts-nocheck
import {
    FEATURED_EVENTS_CHANGED,
    FEATURED_EVENTS_CLEARED,
    FEATURED_LINK_CHANGED,
    FEATURED_LINKS_LIST_RECEIVED,
} from '../types';

const initialState = {
    featuredLinks: [],
    current: null,
    featuredEvents: [],
};

const featuredLinks = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case FEATURED_LINKS_LIST_RECEIVED: {
            return {
                ...state,
                featuredLinks: payload,
            };
        }
        case FEATURED_LINK_CHANGED: {
            return {
                ...state,
                current: payload,
            };
        }
        case FEATURED_EVENTS_CHANGED: {
            return {
                ...state,
                featuredEvents: payload,
            };
        }
        case FEATURED_EVENTS_CLEARED: {
            return {
                ...state,
                featuredEvents: initialState.featuredEvents,
            };
        }
        default: {
            return state;
        }
    }
};

export default featuredLinks;
